import axios from '../../axios/index.js';
import i18n from '../../../i18n/i18n';

export default {
    /**
     * Get application initial configurations
     *
     * @returns {*}
     */
    info () {
        return axios.get('/api/v1/application/info');
    },

    userInfo () {
        return axios.get('/api/v1/user/info');
    },

    usersList () {
        return axios.get('/api/v1/user/list');
    },
    impersonate(id) {
        return axios.post('/api/v1/user/impersonate/'+id);
    },
    stopImpersonate() {
        return axios.delete('/api/v1/user/impersonate');
    },

    /**
     * Get application translations
     *
     * @param locales Array of locales names
     */
    translations (locales) {
        axios.get('/api/v1/application/translations', {
            params: {
                locales: locales,
            },
        }).then(response => {
            Object.keys(response.data.data).forEach(function (lang) {
                i18n.setLocaleMessage(lang, response.data.data[lang]);
            });
        }).catch(error => {
            console.log(error);
        });
    },

    /**
     * Get Media load url response
     *
     * @param url Media load link
     *
     * @returns {Promise<unknown>}
     */
    getMediaLoadUrlResponse (url) {
        return axios.get(url);
    },

    /**
     * Stores uploaded file to media processing list.
     *
     * @param data Data object
     *
     * @returns {Promise<unknown>}
     */
    storeMediaProcessing (data) {
        let formData = new FormData();

        formData.append('onedrive_id', data.id);
        formData.append('filename', data.name);
        formData.append('web_url', data.link);
        formData.append('size', data.size);

        return axios.post('/api/v1/media/processing', formData);
    },



    /**
     * Stores uploaded file to media processing list.
     *
     * @param data Data object
     *
     * @returns {Promise<unknown>}
     */
    storeDoMediaProcessing (data) {
        let formData = new FormData();

        formData.append('bucket', data.bucket);
        formData.append('path', data.path);
        formData.append('filename', data.filename);
        formData.append('web_url', data.web_url);
        formData.append('size', data.size);

        return axios.post('/api/v1/media/processing-do', formData);
    },

    /**
     * Retrieves image data URI to break CORS errors
     *
     * @param mediaId Image media id
     *
     * @returns {*}
     */
    getDataURI (mediaId) {
        return axios.get('/api/v1/media/get-data-uri/' + mediaId);
    },
};
